import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomArrowDown = (props: SvgIconProps): JSX.Element => {
    return (
        <SvgIcon {...props} viewBox="0 0 20 20">
            <path d="M10 17.5L3.75 11.1538L5.20833 9.67308L8.95833 13.4808V2.5H11.0417V13.4808L14.7917 9.67308L16.25 11.1538L10 17.5Z" />
        </SvgIcon>
    );
};
